import { languageMap } from ".."
import { bracketIndenting } from "./shared"

languageMap.bicep = bracketIndenting()
